// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27%3E%3Cpath d=%27M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z%27%3E%3C/path%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%273%27%3E%3C/circle%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27%3E%3Cpath d=%27M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24%27%3E%3C/path%3E%3Cline x1=%271%27 y1=%271%27 x2=%2723%27 y2=%2723%27%3E%3C/line%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LoginStyle.css */

* {
  font-family: 'Montserrat', sans-serif !important;
}

.login-title, .login-subtitle, .auth-headline, .auth-desc,
.login-input, .password-input, .forgot-link, .login-button,
.support-text, .support-link, .version-info {
  font-family: 'Montserrat', sans-serif;
}

.login-title {
  font-weight: 700;
}

.login-subtitle {
  font-weight: 400;
}

.auth-headline {
  font-weight: 600;
}

.auth-desc {
  font-weight: 400;
}

.login-button {
  font-weight: 500;
}

/* Основные стили */
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%); /* Проверка изменения */
  padding: 20px;
  position: relative;
  overflow: hidden;
}

/* Контент */
.login-content {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 440px;
}

/* Карточка */
.login-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  padding: 40px;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Анимированный фон */
.background-animation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.background-animation .shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  animation: float 6s ease-in-out infinite;
}

.login-shape-1 {
  width: 300px;
  height: 300px;
  top: -150px;
  left: -150px;
  animation-delay: 0s;
}

.login-shape-2 {
  width: 200px;
  height: 200px;
  bottom: -100px;
  right: -100px;
  animation-delay: 2s;
}

.login-shape-3 {
  width: 150px;
  height: 150px;
  top: 50%;
  left: 70%;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}



/* Шапка */
.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-title {
  color: white;
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.forgot-link {
  background: transparent;
  border: none;
}

.login-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin: 0;
}

.card-header {
  text-align: center;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Меняем порядок: сначала "Добро пожаловать", потом "Введите данные для входа" */
.login-card .auth-headline {
  color: #002FA7;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  order: 1;
}

.login-card .auth-desc {
  color: #718096;
  font-size: 14px;
  margin: 0;
  order: 2;
}

/* Ошибки */
.login-card .auth-error {
  background: #fed7d7;
  color: #c53030;
  padding: 12px 16px;
  border-radius: 12px;
  
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.login-card .error-icon {
  font-size: 14px;
}

.login-card .error-message {
  font-size: 13px;
  text-align: center;
  color: #c53030;
  margin-bottom: 20px;
}

/* Поля ввода */
.input-group-login {
  margin-bottom: 20px;
}

.input-group-password {
  margin-bottom: 5px;
}

.input-field {
  position: relative;
  display: flex;
  align-items: center;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 0px;
  transition: all 0.3s ease;
}

.input-field:focus-within {
  border-color: #5986f7;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.input-icon {
  font-size: 18px;
  margin-right: 12px;
  color: #a0aec0;
}

.login-input {
  flex: 1 1;
  border: none;
  outline: none;
  padding: 16px 16px;
  font-size: 14px;
  background: transparent;
  border-radius: 10px;
}

.password-input {
  flex: 1 1;
  border: none;
  outline: none;
  padding: 16px 16px;
  font-size: 14px;
  background: transparent;
  border-radius: 10px;
}

.login-input::placeholder {
  color: #a0aec0;
}

.password-input::placeholder {
  color: #a0aec0;
}

.password-toggle {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 0px;
  color: #a0aec0;
  transition: color 0.3s ease;
  margin-left: auto;
}

.password-toggle:hover {
  color: #667eea;
}

/* Забыли пароль */
.forgot-row {
  text-align: right;
  margin-bottom: 30px;
}

.forgot-link {
  color: #3c5ceb;
  text-decoration: none;
  font-size: 12px;
  transition: color 0.3s ease;
}

.forgot-link:hover {
  color: #5b77f4;
  text-decoration: underline;
}

/* Кнопка */
.login-button {
  width: 100%;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  color: white;
  border: none;
  padding: 18px 24px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 15px;
}

.login-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.login-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.button-icon {
  font-size: 18px;
}

.button-loading {
  display: flex;
  align-items: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Футер */
.login-footer {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

.login-footer .support-text {
  color: #718096;
  font-size: 13px;
  text-align: center;
  margin: 0;
}

.support-link {
  color: #3c5ceb;
  text-decoration: none;
  transition: color 0.3s ease;
  font-weight: 400;
}

.support-link:hover {
  color: #5b77f4;
  text-decoration: underline;
}

.version-info {
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  margin-top: 20px;
}

/* Адаптивность */
@media (max-width: 480px) {
  .login-container {
    padding: 16px;
  }
  
  .login-card {
    padding: 30px 24px;
  }
  
  .login-title {
    font-size: 24px;
  }
  
  .auth-headline {
    font-size: 20px;
  }
}


/* Улучшенные стили для модального окна выбора роли */
.lp-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 47, 167, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(6px);
  padding: 20px;
  animation: fadeInOverlay 0.2s ease-out;
}

@keyframes fadeInOverlay {
  from { opacity: 0; }
  to { opacity: 1; }
}

.lp-modal-content {
  background: white;
  border-radius: 12px;
  padding: 28px;
  max-width: 480px;
  width: 100%;
  max-height: 70vh;
  overflow-y: auto;
  box-shadow: 0 12px 28px rgba(0, 47, 167, 0.2);
  border: 1px solid rgba(0, 47, 167, 0.1);
  animation: slideInModal 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.1);
}

@keyframes slideInModal {
  from {
    opacity: 0;
    transform: translateY(-15px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.lp-modal-header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(0, 47, 167, 0.1);
}

.lp-modal-header h3 {
  margin: 0 0 6px 0;
  color: #002FA7;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
}

.lp-modal-header p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}

.lp-roles-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.lp-role-card {
  border: 1px solid #e0e7ff;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  background: #f8f9ff;
  position: relative;
  overflow: hidden;
}

.lp-role-card:hover {
  border-color: #5986f7;
  background: #f0f4ff;
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 47, 167, 0.1);
}

.lp-role-card:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(0, 47, 167, 0.1);
}

.lp-role-card::after {
  content: '';
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid #002FA7;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.lp-role-card:hover::after {
  opacity: 0.5;
}

.lp-role-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
}

.lp-role-header h4 {
  margin: 0;
  color: #1a237e;
  font-size: 16px;
  font-weight: 600;
  flex: 1 1;
}

.lp-role-badge {
  font-size: 11px;
  font-weight: 500;
  color: #002FA7;
  background: rgba(0, 47, 167, 0.1);
  padding: 2px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.lp-role-description {
  margin: 0;
  color: #666;
  font-size: 13px;
  line-height: 1.4;
  padding-right: 20px;
}

.lp-modal-footer {
  display: flex;
  justify-content: center;
  padding-top: 16px;
  border-top: 1px solid rgba(0, 47, 167, 0.1);
}

.lp-cancel-button {
  background: white;
  color: #002FA7;
  border: 1px solid #002FA7;
  padding: 10px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  min-width: 100px;
}

.lp-cancel-button:hover {
  background: #f8f9ff;
  box-shadow: 0 2px 6px rgba(0, 47, 167, 0.1);
}

.lp-cancel-button:active {
  background: #f0f4ff;
  transform: translateY(1px);
}

/* Стили для скроллбара */
.lp-modal-content::-webkit-scrollbar {
  width: 6px;
}

.lp-modal-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.lp-modal-content::-webkit-scrollbar-thumb {
  background: rgba(0, 47, 167, 0.3);
  border-radius: 3px;
}

.lp-modal-content::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 47, 167, 0.5);
}

/* Адаптивность */
@media (max-width: 768px) {
  .lp-modal-overlay {
    padding: 16px;
  }
  
  .lp-modal-content {
    padding: 20px;
    max-height: 75vh;
  }
  
  .lp-modal-header h3 {
    font-size: 18px;
  }
  
  .lp-modal-header p {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .lp-modal-overlay {
    padding: 12px;
  }
  
  .lp-modal-content {
    padding: 16px;
  }
  
  .lp-role-card {
    padding: 14px;
  }
  
  .lp-role-header h4 {
    font-size: 15px;
  }
  
  .lp-role-description {
    font-size: 12px;
  }
  
  .lp-cancel-button {
    padding: 8px 20px;
    font-size: 13px;
  }
}

/* Дополнительные стили для ролей */
.lp-role-info {
  font-size: 12px;
  color: #002FA7;
  font-weight: 500;
  margin-bottom: 12px;
  padding: 4px 8px;
  background: rgba(0, 47, 167, 0.08);
  border-radius: 4px;
  display: inline-block;
}

.lp-role-features {
  margin-top: 8px;
}

.lp-role-feature {
  display: flex;
  align-items: flex-start;
  margin-bottom: 6px;
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

.lp-feature-bullet {
  color: #002FA7;
  font-weight: bold;
  margin-right: 8px;
  flex-shrink: 0;
  line-height: 1.4;
}

/* Увеличение отступов для лучшего отображения списка */
.lp-role-card {
  padding: 20px;
}

.lp-role-header {
  margin-bottom: 12px;
}

/* Изменение фона при наведении */
.lp-role-card:hover .lp-role-feature {
  color: #444;
}

.lp-role-card:hover .lp-feature-bullet {
  color: #1e40af;
}

/* Адаптивные стили */
@media (max-width: 768px) {
  .lp-role-feature {
    font-size: 11px;
  }
  
  .lp-role-info {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .lp-role-feature {
    font-size: 10px;
  }
  
  .lp-role-info {
    font-size: 10px;
  }
  
  .lp-role-card {
    padding: 16px;
  }
}

/* Стили для поля пароля с кнопкой показа */

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  color: #666;
}

.password-toggle:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #333;
}

.password-toggle:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* Стили для иконки глаза */
.eye-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  position: relative;
}

.eye-icon::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 18px;
  height: 18px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.eye-icon.eye-open::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.eye-icon.eye-closed::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

/* Стили для ссылки "Забыли пароль?" */
.forgot-password-container {
  margin-top: 8px;
  text-align: right;
  width: 100%;
}

.forgot-password-link {
  background: none;
  border: none;
  color: #002FA7;
  font-size: 12px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 300;
}

.forgot-password-link:hover {
  color: #1e40af;
  text-decoration: underline;
}

.forgot-password-link:disabled {
  color: #94a3b8;
  cursor: not-allowed;
  text-decoration: none;
}

@media (max-width: 768px) {
  .forgot-password-link {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/LoginStyle.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAGnB;EACE,gDAAgD;AAClD;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D,EAAE,uBAAuB;EACtF,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW,uCAAuC,EAAE;EACpD,MAAM,2CAA2C,EAAE;AACrD;;;;AAIA,UAAU;AACV;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,iFAAiF;AACjF;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA,qDAAqD;AACrD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,uCAAuC;EACvC,kEAAkE;AACpE;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,iDAAiD;EACjD,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,2CAA2C;;AAE3C;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yDAA8R;AAChS;;AAEA;EACE,yDAA0a;AAC5a;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* LoginStyle.css */\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');\n\n* {\n  font-family: 'Montserrat', sans-serif !important;\n}\n\n.login-title, .login-subtitle, .auth-headline, .auth-desc,\n.login-input, .password-input, .forgot-link, .login-button,\n.support-text, .support-link, .version-info {\n  font-family: 'Montserrat', sans-serif;\n}\n\n.login-title {\n  font-weight: 700;\n}\n\n.login-subtitle {\n  font-weight: 400;\n}\n\n.auth-headline {\n  font-weight: 600;\n}\n\n.auth-desc {\n  font-weight: 400;\n}\n\n.login-button {\n  font-weight: 500;\n}\n\n/* Основные стили */\n.login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%); /* Проверка изменения */\n  padding: 20px;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Контент */\n.login-content {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  max-width: 440px;\n}\n\n/* Карточка */\n.login-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  padding: 40px;\n  border-radius: 20px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* Анимированный фон */\n.background-animation {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.background-animation .shape {\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  animation: float 6s ease-in-out infinite;\n}\n\n.login-shape-1 {\n  width: 300px;\n  height: 300px;\n  top: -150px;\n  left: -150px;\n  animation-delay: 0s;\n}\n\n.login-shape-2 {\n  width: 200px;\n  height: 200px;\n  bottom: -100px;\n  right: -100px;\n  animation-delay: 2s;\n}\n\n.login-shape-3 {\n  width: 150px;\n  height: 150px;\n  top: 50%;\n  left: 70%;\n  animation-delay: 4s;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px) rotate(0deg); }\n  50% { transform: translateY(-20px) rotate(180deg); }\n}\n\n\n\n/* Шапка */\n.login-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.login-title {\n  color: white;\n  font-size: 28px;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.forgot-link {\n  background: transparent;\n  border: none;\n}\n\n.login-subtitle {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 14px;\n  margin: 0;\n}\n\n.card-header {\n  text-align: center;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Меняем порядок: сначала \"Добро пожаловать\", потом \"Введите данные для входа\" */\n.login-card .auth-headline {\n  color: #002FA7;\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0;\n  order: 1;\n}\n\n.login-card .auth-desc {\n  color: #718096;\n  font-size: 14px;\n  margin: 0;\n  order: 2;\n}\n\n/* Ошибки */\n.login-card .auth-error {\n  background: #fed7d7;\n  color: #c53030;\n  padding: 12px 16px;\n  border-radius: 12px;\n  \n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.login-card .error-icon {\n  font-size: 14px;\n}\n\n.login-card .error-message {\n  font-size: 13px;\n  text-align: center;\n  color: #c53030;\n  margin-bottom: 20px;\n}\n\n/* Поля ввода */\n.input-group-login {\n  margin-bottom: 20px;\n}\n\n.input-group-password {\n  margin-bottom: 5px;\n}\n\n.input-field {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background: white;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0px;\n  transition: all 0.3s ease;\n}\n\n.input-field:focus-within {\n  border-color: #5986f7;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.input-icon {\n  font-size: 18px;\n  margin-right: 12px;\n  color: #a0aec0;\n}\n\n.login-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  padding: 16px 16px;\n  font-size: 14px;\n  background: transparent;\n  border-radius: 10px;\n}\n\n.password-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  padding: 16px 16px;\n  font-size: 14px;\n  background: transparent;\n  border-radius: 10px;\n}\n\n.login-input::placeholder {\n  color: #a0aec0;\n}\n\n.password-input::placeholder {\n  color: #a0aec0;\n}\n\n.password-toggle {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 0px;\n  color: #a0aec0;\n  transition: color 0.3s ease;\n  margin-left: auto;\n}\n\n.password-toggle:hover {\n  color: #667eea;\n}\n\n/* Забыли пароль */\n.forgot-row {\n  text-align: right;\n  margin-bottom: 30px;\n}\n\n.forgot-link {\n  color: #3c5ceb;\n  text-decoration: none;\n  font-size: 12px;\n  transition: color 0.3s ease;\n}\n\n.forgot-link:hover {\n  color: #5b77f4;\n  text-decoration: underline;\n}\n\n/* Кнопка */\n.login-button {\n  width: 100%;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  color: white;\n  border: none;\n  padding: 18px 24px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 15px;\n}\n\n.login-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n.login-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.button-icon {\n  font-size: 18px;\n}\n\n.button-loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid transparent;\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Футер */\n.login-footer {\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.login-footer .support-text {\n  color: #718096;\n  font-size: 13px;\n  text-align: center;\n  margin: 0;\n}\n\n.support-link {\n  color: #3c5ceb;\n  text-decoration: none;\n  transition: color 0.3s ease;\n  font-weight: 400;\n}\n\n.support-link:hover {\n  color: #5b77f4;\n  text-decoration: underline;\n}\n\n.version-info {\n  text-align: center;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  margin-top: 20px;\n}\n\n/* Адаптивность */\n@media (max-width: 480px) {\n  .login-container {\n    padding: 16px;\n  }\n  \n  .login-card {\n    padding: 30px 24px;\n  }\n  \n  .login-title {\n    font-size: 24px;\n  }\n  \n  .auth-headline {\n    font-size: 20px;\n  }\n}\n\n\n/* Улучшенные стили для модального окна выбора роли */\n.lp-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 47, 167, 0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(6px);\n  padding: 20px;\n  animation: fadeInOverlay 0.2s ease-out;\n}\n\n@keyframes fadeInOverlay {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.lp-modal-content {\n  background: white;\n  border-radius: 12px;\n  padding: 28px;\n  max-width: 480px;\n  width: 100%;\n  max-height: 70vh;\n  overflow-y: auto;\n  box-shadow: 0 12px 28px rgba(0, 47, 167, 0.2);\n  border: 1px solid rgba(0, 47, 167, 0.1);\n  animation: slideInModal 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.1);\n}\n\n@keyframes slideInModal {\n  from {\n    opacity: 0;\n    transform: translateY(-15px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.lp-modal-header {\n  text-align: center;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.lp-modal-header h3 {\n  margin: 0 0 6px 0;\n  color: #002FA7;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.lp-modal-header p {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.lp-roles-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.lp-role-card {\n  border: 1px solid #e0e7ff;\n  border-radius: 8px;\n  padding: 16px;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  background: #f8f9ff;\n  position: relative;\n  overflow: hidden;\n}\n\n.lp-role-card:hover {\n  border-color: #5986f7;\n  background: #f0f4ff;\n  transform: translateY(-1px);\n  box-shadow: 0 3px 8px rgba(0, 47, 167, 0.1);\n}\n\n.lp-role-card:active {\n  transform: translateY(0);\n  box-shadow: 0 1px 3px rgba(0, 47, 167, 0.1);\n}\n\n.lp-role-card::after {\n  content: '';\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 5px solid #002FA7;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.lp-role-card:hover::after {\n  opacity: 0.5;\n}\n\n.lp-role-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 4px;\n}\n\n.lp-role-header h4 {\n  margin: 0;\n  color: #1a237e;\n  font-size: 16px;\n  font-weight: 600;\n  flex: 1;\n}\n\n.lp-role-badge {\n  font-size: 11px;\n  font-weight: 500;\n  color: #002FA7;\n  background: rgba(0, 47, 167, 0.1);\n  padding: 2px 8px;\n  border-radius: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.lp-role-description {\n  margin: 0;\n  color: #666;\n  font-size: 13px;\n  line-height: 1.4;\n  padding-right: 20px;\n}\n\n.lp-modal-footer {\n  display: flex;\n  justify-content: center;\n  padding-top: 16px;\n  border-top: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.lp-cancel-button {\n  background: white;\n  color: #002FA7;\n  border: 1px solid #002FA7;\n  padding: 10px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  min-width: 100px;\n}\n\n.lp-cancel-button:hover {\n  background: #f8f9ff;\n  box-shadow: 0 2px 6px rgba(0, 47, 167, 0.1);\n}\n\n.lp-cancel-button:active {\n  background: #f0f4ff;\n  transform: translateY(1px);\n}\n\n/* Стили для скроллбара */\n.lp-modal-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.lp-modal-content::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.lp-modal-content::-webkit-scrollbar-thumb {\n  background: rgba(0, 47, 167, 0.3);\n  border-radius: 3px;\n}\n\n.lp-modal-content::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 47, 167, 0.5);\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .lp-modal-overlay {\n    padding: 16px;\n  }\n  \n  .lp-modal-content {\n    padding: 20px;\n    max-height: 75vh;\n  }\n  \n  .lp-modal-header h3 {\n    font-size: 18px;\n  }\n  \n  .lp-modal-header p {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .lp-modal-overlay {\n    padding: 12px;\n  }\n  \n  .lp-modal-content {\n    padding: 16px;\n  }\n  \n  .lp-role-card {\n    padding: 14px;\n  }\n  \n  .lp-role-header h4 {\n    font-size: 15px;\n  }\n  \n  .lp-role-description {\n    font-size: 12px;\n  }\n  \n  .lp-cancel-button {\n    padding: 8px 20px;\n    font-size: 13px;\n  }\n}\n\n/* Дополнительные стили для ролей */\n.lp-role-info {\n  font-size: 12px;\n  color: #002FA7;\n  font-weight: 500;\n  margin-bottom: 12px;\n  padding: 4px 8px;\n  background: rgba(0, 47, 167, 0.08);\n  border-radius: 4px;\n  display: inline-block;\n}\n\n.lp-role-features {\n  margin-top: 8px;\n}\n\n.lp-role-feature {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 6px;\n  font-size: 12px;\n  color: #666;\n  line-height: 1.4;\n}\n\n.lp-feature-bullet {\n  color: #002FA7;\n  font-weight: bold;\n  margin-right: 8px;\n  flex-shrink: 0;\n  line-height: 1.4;\n}\n\n/* Увеличение отступов для лучшего отображения списка */\n.lp-role-card {\n  padding: 20px;\n}\n\n.lp-role-header {\n  margin-bottom: 12px;\n}\n\n/* Изменение фона при наведении */\n.lp-role-card:hover .lp-role-feature {\n  color: #444;\n}\n\n.lp-role-card:hover .lp-feature-bullet {\n  color: #1e40af;\n}\n\n/* Адаптивные стили */\n@media (max-width: 768px) {\n  .lp-role-feature {\n    font-size: 11px;\n  }\n  \n  .lp-role-info {\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 480px) {\n  .lp-role-feature {\n    font-size: 10px;\n  }\n  \n  .lp-role-info {\n    font-size: 10px;\n  }\n  \n  .lp-role-card {\n    padding: 16px;\n  }\n}\n\n/* Стили для поля пароля с кнопкой показа */\n\n.password-toggle {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n  color: #666;\n}\n\n.password-toggle:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: #333;\n}\n\n.password-toggle:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n/* Стили для иконки глаза */\n.eye-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  position: relative;\n}\n\n.eye-icon::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 18px;\n  height: 18px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.eye-icon.eye-open::before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'%3E%3Cpath d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z'%3E%3C/path%3E%3Ccircle cx='12' cy='12' r='3'%3E%3C/circle%3E%3C/svg%3E\");\n}\n\n.eye-icon.eye-closed::before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'%3E%3Cpath d='M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24'%3E%3C/path%3E%3Cline x1='1' y1='1' x2='23' y2='23'%3E%3C/line%3E%3C/svg%3E\");\n}\n\n/* Стили для ссылки \"Забыли пароль?\" */\n.forgot-password-container {\n  margin-top: 8px;\n  text-align: right;\n  width: 100%;\n}\n\n.forgot-password-link {\n  background: none;\n  border: none;\n  color: #002FA7;\n  font-size: 12px;\n  cursor: pointer;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  font-weight: 300;\n}\n\n.forgot-password-link:hover {\n  color: #1e40af;\n  text-decoration: underline;\n}\n\n.forgot-password-link:disabled {\n  color: #94a3b8;\n  cursor: not-allowed;\n  text-decoration: none;\n}\n\n@media (max-width: 768px) {\n  .forgot-password-link {\n    font-size: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
